import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import StatsSection from "./components/StatsSection";
import KeyFeatures from "./components/KeyFeatures";
import HowItWorks from "./components/HowItWorks";
import PricingSection from "./components/PricingSection";
import EmpoweringSection from "./components/EmpoweringSection";
import NextSection from "./components/NextSection";
import Footer from "./components/Footer";
import Pricing from "./pages/Pricing";
import About from "./pages/About";
import Contact from "./pages/Contact";
import SignUp from "./components/SignUp";
import OtpVerification from "./pages/OtpVerification";
import SetPassword from "./pages/SetPassword";
import ForgotPassword from "./pages/ForgotPassword";
import CheckInbox from "./pages/CheckInbox";
import PasswordResetInfo from "./pages/PasswordResetInfo";
import Login from "./components/Login";
import Dashboard from "./pages/Dashboard";
import PaymentPage from "./pages/PaymentPage";
import SuccessPage from "./pages/SuccessPage";
import { GoogleOAuthProvider } from "@react-oauth/google";
import VerifyNotice from "./pages/VerifyNotice";
import DispatchHistory from "./pages/DispatchHistory";
import CreateDocument from "./pages/CreateDocument";
import ProtectedRoute from "./auth/ProtectedRoute";
import AdminDashboard from "./pages/AdminDashboard";
import TrackPage from "./pages/TrackPage";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import PublicRoute from "./auth/PublicRoute";
import "./styles/Navbar.css";
import VerifyEmail from "./pages/VerifyEmail";
import Refund from "./pages/Refund";
import LegalHome from "./pages/LegalHome";

// ✅ Wrapper to handle Navbar visibility
const AppWrapper = () => {
  const location = useLocation();

  // Hide Navbar on admin and dashboard routes
  const hideNavbar =
    location.pathname.startsWith("/admin") ||
    location.pathname.startsWith("/dashboard") ||
    location.pathname.startsWith("/dispatch-history") ||
    location.pathname.startsWith("/payment") ||
    location.pathname.startsWith("/success") ||
    location.pathname.startsWith("/create") ||
    location.pathname.startsWith("/track");

  return (
    <div className="main-container">
      {!hideNavbar && <Navbar />}
      <ScrollToTop />  {/* ✅ Add this here */}
      <Routes>
        {/* Home Page */}
        <Route
          path="/"
          element={
            <>
              <Hero />
              <StatsSection />
              <KeyFeatures />
              <HowItWorks />
              <PricingSection />
              <EmpoweringSection />
              <NextSection />
              <Footer />
            </>
          }
        />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        
        {/* <Route path="/signup" element={<SignUp />} /> */}
        {/* <Route path="/login" element={<Login />} /> */}
        <Route path="/otp-verification" element={<OtpVerification />} />
        <Route path="/password-reset" element={<PasswordResetInfo />} />
        <Route path="/set-password" element={<SetPassword />} />
        <Route path="/check-inbox" element={<CheckInbox />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        {/* <Route path="/payment" element={<PaymentPage />} /> */}
        {/* <Route path="/success" element={<SuccessPage />} /> */}
        <Route path="/verify-notice" element={<VerifyNotice />} />
        {/* <Route path="/dispatch-history" element={<DispatchHistory />} /> */}
        {/* <Route path="/create" element={<CreateDocument />} /> */}
        <Route path="/track" element={<TrackPage />} />
        <Route path="/track/:trackingId" element={<TrackPage />} />

        {/* <Route path="/dashboard" element={<Dashboard />} /> */}
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />

        {/* ✅ Admin Section (no Navbar) */}
        <Route path="/admin-dashboard" element={<AdminDashboard />} />

        <Route path="/verify/:token" element={<VerifyEmail />} />
        <Route path="/LegalHome" element={<LegalHome />} />
        <Route path="/refund" element={<Refund />} />
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />



        <Route
          path="/signup"
          element={
            <PublicRoute>
              <SignUp />
            </PublicRoute>
          }
        />
        {/* Protected Pages */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dispatch-history"
          element={
            <ProtectedRoute>
              <DispatchHistory />
            </ProtectedRoute>
          }
        />

        <Route
          path="/create"
          element={
            <ProtectedRoute>
              <CreateDocument />
            </ProtectedRoute>
          }
        />

        <Route
          path="/payment"
          element={
            <ProtectedRoute>
              <PaymentPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/success"
          element={
            <ProtectedRoute>
              <SuccessPage />
            </ProtectedRoute>
          }
        />


      </Routes>
    </div>
  );
};


const App = () => (
  <Router>
    <AppWrapper />
  </Router>
);

export default App;
